import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProdutoRoutingModule } from './produto-routing.module';
import { ServicoPage } from 'src/app/pages/servico/servico-page/servico-page.component';
import { LoaderModule } from '../../loader/loader/loader.module';
import { ProdutoPageFotosComponent } from 'src/app/components/produto/produto-page-fotos/produto-page-fotos.component';
import { PipeModule } from '../../pipe/pipe.module';
import { PartialModule } from '../../partial/partial.module';
import { ProdutoVendaOfflineComponent } from 'src/app/components/produto/produto-venda-offline/produto-venda-offline.component';
import { BtnModule } from '../../btn/btn/btn.module';
import { FormsModule } from '@angular/forms';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import { ProdutoPartialModule } from '../produto-partial/produto-partial.module';
import { ProdutoInclusoModule } from '../produto-incluso/produto-incluso.module';
import { CartAddModule } from '../../carrinho/cart-add/cart-add.module';
import { ProdutoPageFotosModule } from '../produto-page-fotos/produto-page-fotos.module';
import { CartEditModule } from '../../carrinho/cart-edit/cart-edit.module';
import { ProdutoItemValorModule } from '../produto-item-valor/produto-item-valor.module';
import { BtnFavoritoModule } from '../../btn/btn-favorito/btn-favorito.module';
import { ModuloModule } from '../../modulo/modulo.module';
import { ProdutoFaqComponent } from 'src/app/components/produto/produto-faq/produto-faq.component';
import { DuvidaFrequenteModule } from '../../duvida-frequente/duvida-frequente.module';

@NgModule({
  declarations: [
    ServicoPage,
    ProdutoVendaOfflineComponent,
    ProdutoFaqComponent
  ],
  exports: [
    ServicoPage,
    ProdutoVendaOfflineComponent,
    ProdutoFaqComponent 
  ],
  imports: [
    ModuloModule,
    CartEditModule,
    CartAddModule, 
    ProdutoItemValorModule,  
    ProdutoInclusoModule, 
    BtnModule,
    ProdutoPartialModule,
    ProdutoPageFotosModule,
    LoaderModule,
    LazyLoadImageModule,
    PipeModule,
    PartialModule,  
    CommonModule,
    ProdutoRoutingModule,
    FormsModule,
    BtnFavoritoModule,
    DuvidaFrequenteModule
  ]
})
export class ProdutoModule { }
